import { render } from "./icon-close.vue?vue&type=template&id=052f53e3"
const script = {}

import exportComponent from "/Users/justindavis/idfive/dev-umd2/docroot/modules/custom/agnr-idfive-calendar-client/calendar_vue_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__